/**
 * Vorlagenbereich für den Upload mehrerer Bilder zu einem Vorgang
 */

import * as React from 'react';
import { observer } from 'mobx-react';
import Dropzone = require('react-dropzone');
import { Button, Panel, FormControl, FormGroup, InputGroup, ControlLabel } from 'react-bootstrap';
import { observable, action, computed } from 'mobx';
import { ApiStore } from '../../stores/ApiStore';
import { inject, bind } from '../../utils/decorators';
import { VorgangStore } from '../../stores/VorgangStore';
import FaIcon from '../site/FaIcon';

interface IFotoUpload {
  vorgangId: string;
  beschreibung?: string;
  kategorie?: string;
  kategorien: string[];
}

@observer
export default class FotoUpload extends React.Component<IFotoUpload, {}> {

  @inject(ApiStore) apiStore: ApiStore;
  @inject(VorgangStore) vorgangStore: VorgangStore;

  @observable dragging: boolean = false;
  @observable acceptedFiles?: File[];
  @observable kategorie?: string;

  componentDidMount() {
    this.kategorie = this.props.kategorie;
  }

  componentWillReceiveProps(nextProps: IFotoUpload) {
    if (nextProps.kategorie !== this.props.kategorie) {
      this.kategorie = nextProps.kategorie;
    }
  }

  @computed get filesSelected() {
    return ((this.acceptedFiles !== undefined) && this.acceptedFiles.length > 0);
  }

  @bind @action handleFileDrop(accepted: File[]) {
    if (accepted.length > 0) {
      this.acceptedFiles = Array.from(accepted);
    }
    this.handleSetDragging(false);
  }

  @bind @action handleFileDropRejected(rejected: File[]) {
    this.handleClearAcceptedFile();
    this.handleSetDragging(false);
  }

  @bind @action handleClearAcceptedFile() {
    this.acceptedFiles = undefined;
  }

  @action handleSetDragging(dragging: boolean) {
    this.dragging = dragging;
  }

  @bind async handleUpload() {
    if (this.acceptedFiles && this.kategorie) {
      const { vorgangId } = this.props;
      const response = await this.apiStore.vorgangFotoUpload(vorgangId, this.kategorie, this.acceptedFiles);
      if (response.ok) {
        this.handleClearAcceptedFile();
        this.vorgangStore.loadVorgang(vorgangId);
      }
    }
  }

  @bind @action handleKategorieChanged(event: React.FormEvent<FormControl>) {
    this.kategorie = (event.target as HTMLInputElement).value;
  }

  render() {
    // tslint:disable-next-line:no-any
    let dropZone: any;

    return (
      <Panel
        header={'Fotos auswählen'}
        bsStyle="info"
        footer={(
          <div className="text-right">
            {this.filesSelected ? (
              <div>
              <Button onClick={this.handleClearAcceptedFile}>Abbrechen</Button>
              <Button bsStyle="primary" onClick={this.handleUpload} disabled={!this.kategorie}>Ausgewählte Datei hochladen</Button>
              </div>
            ) : (
              <Button onClick={() => dropZone.open()}>Dateien auswählen</Button>
            )}
          </div>
        )}
      >
        <Dropzone
          accept=".jpg,.jpeg,.png"
          ref={ref => dropZone = ref}
          multiple={true}
          disableClick={true}
          style={{}}
          className={`upload-dropzone ${this.dragging ? 'upload-dropzone-dragging' : ''}`}
          onDragEnter={() => this.handleSetDragging(true)}
          onDragLeave={() => this.handleSetDragging(false)}
          onDropAccepted={this.handleFileDrop}
          onDropRejected={this.handleFileDropRejected}
        >
          {this.filesSelected ? (
            <div>
              {this.acceptedFiles ?
              <div>
                <h4>{this.acceptedFiles.length} Datei(en) ausgewählt:</h4>
                <div>
                  <ul>{this.acceptedFiles.map((file, index) => <li key={index}>{file.name} ({Math.ceil(10 * file.size / 1024 / 1024) / 10} MB) </li> )}</ul>
                </div>
              </div> : null}
              <FormGroup controlId="Kategorie">
                <InputGroup>
                  <InputGroup.Addon>
                    <ControlLabel>Kategorie</ControlLabel>
                  </InputGroup.Addon>
                  <FormGroup controlId="auswahlKategorie">
                    <FormControl componentClass="select" placeholder="Foto-Kategorie wählen" onChange={this.handleKategorieChanged}>
                      <option value="">Fotokategorie auswählen...</option>
                      {this.props.kategorien.map((kategorie, index) =>
                        <option key={kategorie} value={kategorie}>{kategorie}</option>
                      )}
                    </FormControl>
                  </FormGroup>
                </InputGroup>
              </FormGroup>
            </div>
          ) : (
            <div>
              <div className="text-center">
                <div style={{fontSize: '4em'}}><FaIcon icon="cloud-upload" /></div>
                <div>
                  Dateien auswählen oder per Drag&Drop auf die Fläche fallen lassen.<br/>
                  Unterstützte Formate: jpg, jpeg, png
                </div>
              </div>
            </div>
          )}
        </Dropzone>
      </Panel>
    );
  }

}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/vorlagen/FotoUpload.tsx